import type { ProviderInfo, TemplateKind } from './types';

export interface DownloadChoice {
  kind: TemplateKind;
  label: string;
  description: string;
}

/** The downloads that belong to a native EPN format. Providers with no template get none. */
export function downloadsFor(provider: ProviderInfo): DownloadChoice[] {
  switch (provider.templateKind) {
    case 'template':
      return [
        { kind: 'template', label: 'Download template package', description: 'The empty package structure to fill in from your payroll records.' },
        { kind: 'sample', label: 'Download sample package (synthetic data)', description: 'A completed example built from fictitious data, to show what a finished package looks like.' },
        { kind: 'instructions', label: 'Download import instructions', description: 'Step-by-step guidance for preparing and exporting your package.' },
      ];
    case 'standard-template':
      return [
        { kind: 'standard-template', label: 'Download EPN Payroll History Template', description: 'The empty Excel workbook. Fill it in with payroll history from any system.' },
        { kind: 'standard-example', label: 'Download Completed Example', description: 'The same workbook already filled in with fictitious data, to show what a finished file looks like.' },
      ];
    default:
      return [];
  }
}
